import { BASE_URL, IS_LOCALHOST } from "@/config/Constants";

export const SERVER_URL = IS_LOCALHOST ? "http://localhost:3002" : "https://manageui.jobspreader.com";
//export const SERVER_URL = "";
export const DEDICATED_SERVER_URL = "https://manageui.jobspreader.com";
const API_BASE_PATH = `${IS_LOCALHOST ? "/api" : ""}/admin/api/`;
export const PF_BASE_URL = SERVER_URL + `${API_BASE_PATH}simplifyAdmin`;
export const Login_BASE_URL = SERVER_URL + `${API_BASE_PATH}login`;
export const SET_PF_BASE_URL = SERVER_URL + `${API_BASE_PATH}portfolioUpdate`;

export const NEW_SESSION_API_URL = SERVER_URL + `${API_BASE_PATH}getSession`;
export const SITE_URL = SERVER_URL + BASE_URL;
export const LOGIN_URL = SITE_URL + "/login";


export const SYSTEM_ERROR = "System error. Please try again later!";
export const PHP_LOGOUT_URL = SERVER_URL + `${API_BASE_PATH}logout`;
export const TRANSLATION_BASE_URL = SERVER_URL + `${IS_LOCALHOST ? "/api" : ""}/admin/locale/`;
